import MaterialIcon from '@material/react-material-icon/';
import PropTypes from 'prop-types';

class Icon extends MaterialIcon {
	render() {
		return super.render();
	}
}

// documentation: https://github.com/material-components/material-components-web-react/tree/master/packages/material-icon#props
Icon.propTypes = {
	hasRipple: PropTypes.bool,
	icon: PropTypes.string,
};

export default MaterialIcon;
